export default import.meta.ROLLUP_FILE_URL_qZZZ7EOcQU0bnm2SE9d1Ig;